export default __webpack_public_path__ + "3b27e9dcf1e2f7dea306bfe92727a37b.gif";